import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function Oferta1la1FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: 'Ce este Theta Healing®?',
    a: 'Theta Healing® este o tehnică prin care accesăm starea theta a creierului — aceeași stare în care se imprimă credințele în copilărie. Din acea stare, credințele limitative pot fi eliberate și înlocuite cu altele care îți susțin viața. Este o muncă de profunzime, sigură și ghidată.'
  }, {
    q: 'Ședințele sunt online sau la cabinet?',
    a: 'Ambele variante sunt disponibile. Funcționează la fel de bine online (prin Zoom) ca și fizic. Tu alegi varianta care îți este mai confortabilă.'
  }, {
    q: 'Cât durează o ședință?',
    a: 'O ședință durează între 60 și 75 de minute, în funcție de profunzimea temei și de ritmul tău. Nu grăbim niciodată procesul.'
  }, {
    q: 'Cât de des recomandați ședințele?',
    a: 'Pentru pachetul de 6 ședințe, recomandarea este la 1-2 săptămâni distanță, astfel încât să ai timp să integrezi între întâlniri. Pentru ședințe individuale, depinde de tema ta.'
  }, {
    q: 'Voi simți ceva în timpul ședinței?',
    a: 'Cei mai mulți participanți descriu o stare profundă de relaxare, uneori emoții care se eliberează (lacrimi, ușurare), uneori senzații fizice (căldură, furnicături). Toate sunt normale și sigure.'
  }, {
    q: 'În cât timp văd rezultate?',
    a: 'Multe persoane simt o schimbare interioară chiar la finalul ședinței. Rezultatele exterioare — în relații, bani, sănătate — apar pe măsură ce subconștientul nou se manifestă în decizii și acțiuni. Asta cere de obicei câteva săptămâni sau luni.'
  }, {
    q: 'Pot face ședințe dacă urmez deja terapie cu un psiholog?',
    a: 'Da. Theta Healing® este complementară psihoterapiei, nu o înlocuiește. Multe persoane combină cele două abordări cu rezultate excelente. Discutăm la prima ședință despre cum se potrivesc cu situația ta.'
  }];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1708">
      <div className="max-w-4xl mx-auto px-6" data-id="element-1709">
        <SectionHeading title="Întrebări Frecvente" data-id="element-1710" />

        <div className="space-y-4 mb-16" data-id="element-1711">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="border border-brand-text/10 rounded-2xl overflow-hidden bg-brand-cream/50" data-id="element-1712">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-1713">
                <span className="font-bold text-lg text-brand-text pr-8" data-id="element-1714">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-brand-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-1715" />
              </button>
              <AnimatePresence data-id="element-1716">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-1717">
                    <div className="px-6 pb-5 text-brand-textSec leading-relaxed" data-id="element-1718">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1719">
          <CTAButton data-id="element-1720" />
        </motion.div>
      </div>
    </section>;
}